<template>
  <div
    class="element progress-indicator draggable"
    :class="element.progressIndicatorStyle"
    :style="[getBasicStyles]">
    <div
      v-if="element.progressIndicatorStyle === 'stories'"
      class="progress-stories-wrap"
      :style="[getBasicStyles]"
    >
      <div
        v-for="(slide, index) in demoSlideCount"
        :key="index"
        class="stories-bar"
        :style="getFillStyle(index)"
      />
    </div>
    <div
      v-if="element.progressIndicatorStyle === 'single'"
      class="progress-single-wrap"
      :style="{ backgroundColor: element.barBackgroundColor }"
    >
      <div
        class="progress-bar"
        :style="{ backgroundColor: element.barFillColor }"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { forEach } from 'lodash-es';
import ResizeMixins from '../../../../mixins/resize-mixins';
import MoveMixins from '../../../../mixins/move-mixins';

export default {
  name: 'ProgressIndicator',
  props:['element'],
  mixins: [ MoveMixins, ResizeMixins],
  data() {
    return {
      demoSlideIndex: 2,
      demoSlideCount: 5,
    };
  },
  computed: {
    ...mapState({
      selectedElements: (state) => state.templates.selectedElements,
    }),

    ...mapGetters('graphicsTemplate', ['getElementGroupMap']),

    ...mapGetters('panAndZoom', { scaleFactor: 'getScaleFactor' }),

    getBasicStyles() {
      const stylesObj = {};
      const needsPixelsArray = ['top', 'left', 'width', 'height'];

      forEach(this.element.styles, (value, key) => {
        stylesObj[key] = value;
        if (needsPixelsArray.indexOf(key) !== -1) {
          stylesObj[key] = `${value}px`;
        }
      });

      return stylesObj;
    },
    // patch needed things for move-mixin
    styles() {
      return this.getBasicStyles;
    },
    id() {
      return this.element.id;
    },
  },
  methods: {
    ...mapActions('graphicsTemplate', [
      'setElementStylesValueByProp',
    ]),
    updateStyles(value, options) {
      return this.setElementStylesValueByProp({ value, options });
    },
    getElementById(id) {
      if (id === this.id) {
        return this.element;
      }
      return {};
    },
    getFillStyle(index) {
      if (index < this.demoSlideIndex) {
        return { backgroundColor: this.element.barFillColor };
      }
      return { backgroundColor: this.element.barBackgroundColor };
    },
  },
};
</script>
